// this hook is for handle file upload and show preview basically for multiple file upload operation with delete that file after

import { Dispatch, SetStateAction, useRef, useState } from "react";
import { allowedExtensions, Utilfilesizes } from "./environment";

// uploading also
type FileUploadHandlerType = {
  fileuploadFinallyCallback?: () => void;
};
const useFileUploadHandler = ({
  fileuploadFinallyCallback,
}: FileUploadHandlerType) => {
  const multiFormFileRef = useRef<any>();
  const [images, setImages] = useState<any[]>([]);

  //  ******************   Check File Extension is valid or not ************************** ///
  const isFileExtensionValid = (file: any) => {
    // const allowedExtensions = ["pdf"];
    const fileExtension = file.name?.split(".").pop().toLowerCase();
 

    if (file.size > 2097152 || !allowedExtensions.includes(fileExtension))
      return false;
    return true;
  };

  //  *************************   file cursor clearance    **************************
  const fileCursorClearence = () => {
    if (multiFormFileRef?.current) {
      multiFormFileRef.current.value = null;
    }
    fileuploadFinallyCallback?.();
  };

  //  *******************   File upload success handler for preview that image and store into local state ******************* //
  const FileUploadSuccessHandler = (file: any) => {
    let reader = new FileReader();

    reader.onloadend = () => {
      setImages([
        {
          filename: file.name,
          filetype: file.type,
          fileimage: reader.result,
          datetime: file.lastModifiedDate.toLocaleString("en-IN"),
          filesize: Utilfilesizes(file.size),
        },
      ]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }

    fileuploadFinallyCallback?.();
    fileCursorClearence();
  };

  //   ******************   Delete previewed image ******************  //
  const deleteSelectedFileHandler = (selectedFileID: any) => {
    setImages((prev: Array<any>) =>
      prev.filter((self: any) => self.id !== selectedFileID)
    );
  };

  const clearAllFiles = () => {
    setImages([]);
  };

  return {
    deleteSelectedFileHandler,
    FileUploadSuccessHandler,
    multiFormFileRef,
    images,
    fileCursorClearence,
    isFileExtensionValid,
    clearAllFiles,
  };
};
export default useFileUploadHandler;
